import mongoose from 'mongoose';
import { query as queryModel } from './util';

const { Schema } = mongoose;

const TeamsSchema = new Schema({
  team_id: { type: String },
  display_name: { type: String },
});

TeamsSchema.index(
  { team_id: 1 },
  { unique: true, background: true, dropDups: true },
);

TeamsSchema.index(
  { display_name: 1 },
  { unique: true, background: true, dropDups: true },
);

export const TeamsModel = () => mongoose.model('teams', TeamsSchema, 'Teams');

export const query = queryModel(TeamsModel);

TeamsSchema.statics.createTeam = (model) => {
  const Teams = TeamsModel();

  return new Teams(model).save();
};

TeamsSchema.statics.findTeams = (filter, skip, limit) => {
  const Teams = TeamsModel();

  return Teams.find({
    $or: [
      { team_id: filter },
      { display_name: { $regex: `.*${filter}.*`, $options: 'i' } },
    ],
  })
    .limit(limit)
    .skip(skip);
};

TeamsSchema.statics.findTeamsCount = (filter) => {
  const Teams = TeamsModel();

  return Teams.find({ team_id: { $regex: `.*${filter}.*` } }).countDocuments();
};

TeamsSchema.statics.findTeamById = (id) => {
  const Teams = TeamsModel();

  return Teams.findOne({ team_id: id });
};

TeamsSchema.statics.findTeamsByDisplayName = (filter, skip, limit) => {
  const Teams = TeamsModel();

  return Teams.find({
    display_name: { $regex: `.*${filter}.*`, $options: 'i' },
  })
    .limit(limit)
    .skip(skip);
};

TeamsSchema.statics.findTeamsCountByDisplayName = (filter) => {
  const Teams = TeamsModel();

  return Teams.find({
    display_name: { $regex: `.*${filter}.*`, $options: 'i' },
  }).countDocuments();
};

TeamsSchema.statics.deleteTeamByTeamId = (id) => {
  const Teams = TeamsModel();

  return Teams.findOneAndRemove({ team_id: id });
};

TeamsSchema.statics.deleteTeamByTeamByDisplayName = (id) => {
  const Teams = TeamsModel();

  return Teams.findOneAndRemove({ display_name: id });
};

TeamsSchema.statics.findTeamByTeamId = (id) => {
  const Teams = TeamsModel();

  return Teams.findOne({ team_id: id });
};

TeamsSchema.statics.findTeamByTeamDisplayName = (id) => {
  const Teams = TeamsModel();

  return Teams.findOne({ display_name: id });
};

TeamsSchema.statics.findAllTeams = () => {
  const Teams = TeamsModel();

  return Teams.find({}).lean();
};

TeamsSchema.statics.changeTeamDisplayNameById = (id, newDisplayName) => {
  const Teams = TeamsModel();

  return Teams.findOneAndUpdate(
    { team_id: id },
    { $set: { display_name: newDisplayName } },
    {
      new: true,
      overwrite: false,
      upsert: false,
      strict: false,
    },
  );
};

export default TeamsModel;
